(() => {
  const MOBILE_BREAKPOINT = 989;
  const html = document.documentElement;

  const syncScrollLock = () => {
    const hasOpenDrawer = document.querySelector('.cotton-header.cotton-header--menu-open');
    if (hasOpenDrawer) {
      html.setAttribute('scroll-lock', '');
    } else {
      html.removeAttribute('scroll-lock');
    }
  };

  const closeHeaderMenu = (header) => {
    header.classList.remove('cotton-header--menu-open');
    syncAria(header);
    syncScrollLock();
  };

  const syncAria = (header) => {
    const menuToggle = header.querySelector('.cotton-header__menu-toggle');
    const searchToggle = header.querySelector('.cotton-header__search-toggle');

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', header.classList.contains('cotton-header--menu-open') ? 'true' : 'false');
    }

    if (searchToggle) {
      searchToggle.setAttribute('aria-expanded', header.classList.contains('cotton-header--search-open') ? 'true' : 'false');
    }
  };

  const closeAllOnDesktop = () => {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      document.querySelectorAll('.cotton-header').forEach((header) => {
        header.classList.remove('cotton-header--menu-open', 'cotton-header--search-open');
        syncAria(header);
      });
      syncScrollLock();
    }
  };

  document.addEventListener('click', (event) => {
    const submenuToggle = event.target.closest('.cotton-header__submenu-toggle');
    if (submenuToggle) {
      const item = submenuToggle.closest('.cotton-header__menu-item.has-children, .cotton-header__submenu-item.has-children');
      if (!item) return;

      const isOpen = item.classList.toggle('is-open');
      submenuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      const siblingItems = item.parentElement ? Array.from(item.parentElement.children) : [];
      siblingItems.forEach((sibling) => {
        if (sibling === item) return;
        sibling.classList.remove('is-open');
        const siblingToggle = sibling.querySelector(':scope > .cotton-header__menu-row > .cotton-header__submenu-toggle');
        if (siblingToggle) {
          siblingToggle.setAttribute('aria-expanded', 'false');
        }
      });
      return;
    }

    const menuToggle = event.target.closest('.cotton-header__menu-toggle');
    if (menuToggle) {
      const header = menuToggle.closest('.cotton-header');
      if (!header) return;

      const isOpen = header.classList.toggle('cotton-header--menu-open');
      if (isOpen) {
        header.classList.remove('cotton-header--search-open');
      }
      syncAria(header);
      syncScrollLock();
      return;
    }

    const searchToggle = event.target.closest('.cotton-header__search-toggle');
    if (searchToggle) {
      const header = searchToggle.closest('.cotton-header');
      if (!header) return;

      const isOpen = header.classList.toggle('cotton-header--search-open');
      if (isOpen) {
        closeHeaderMenu(header);
      }
      const tagline = header.querySelector('.cotton-header__tagline');
      if (tagline) {
        tagline.classList.toggle('cotton-header__tagline--hidden', isOpen || window.scrollY > 10);
      }
      syncAria(header);
      syncScrollLock();
      return;
    }

    const overlay = event.target.closest('.cotton-header__mobile-overlay');
    if (overlay) {
      const header = overlay.closest('.cotton-header');
      if (!header) return;
      closeHeaderMenu(header);
      return;
    }

    const menuLink = event.target.closest('.cotton-header__bottom-nav a');
    if (menuLink) {
      const header = menuLink.closest('.cotton-header');
      if (!header) return;
      closeHeaderMenu(header);
      return;
    }

    const openHeader = document.querySelector('.cotton-header.cotton-header--menu-open');
    if (openHeader) {
      const nav = openHeader.querySelector('.cotton-header__bottom-nav');
      const toggle = openHeader.querySelector('.cotton-header__menu-toggle');
      if (nav && !nav.contains(event.target) && toggle && !toggle.contains(event.target)) {
        closeHeaderMenu(openHeader);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cotton-header.cotton-header--menu-open').forEach((header) => {
      closeHeaderMenu(header);
    });
  });

  window.addEventListener('resize', closeAllOnDesktop);
  window.addEventListener('orientationchange', closeAllOnDesktop);
  closeAllOnDesktop();
})();
